<template>
  <article class="m-card-element m-card-element-design-2 m-card-primary m-card-transition">

    <div class="m-card-element-info-data">
      <AtomListElementActionsSecondary
        v-if="!hideMoveIcon"
        :element="element"
      />
      <AtomListElementActionsPrimary
        v-if="$route.name === 'products' || $route.name === 'projects'"
        :element="element"
      />

      <div
        v-if="showSelected && parseInt($route.params.subid) === 2"
        class="m-card-element-info-data-selected"
      >
        {{ $t('mFeedSectionContentCardDesing2.selected') }}
      </div>

      <img
        v-if="tarjeta.metadata.imagen"
        :alt="elementNombre"
        id="tarjetaImagen"
        :src="tarjeta.metadata.imagen"
      >
      <img
        v-else
        :alt="elementNombre"
        id="tarjetaImagen"
        src="@/assets/img/ds2.png"
      >

      <h5
        v-if="isAProductRoute && element.categoria !== undefined"
        key="categoryName"
      >
        {{ productoCategoriaNombre }}
      </h5>
      <h5
        v-else-if="isAProductRoute"
        key="noCategoryName"
      >
        {{ $t('mFeedSectionContentCardDesing2.noCategoryName') }}
      </h5>

      <h5 v-if="isAnAssetRoute || isAssetIncludedEdition || isAMapRoute">
        <span v-if="element.tipo === 1">
          Mapa
        </span>
        <span v-else>
          Curso
        </span>
      </h5>

      <h2 class="m-card-element-design-2-name">
        {{ elementNombre }}
      </h2>
    </div>

    <div
      v-if="isAnAssetRoute || isAssetIncludedEdition || isAMapRoute"
      class="m-card-element-info-state"
    >
      <div class="m-card-element-info-state-of-access">
        <h3
          v-if="element.publicado"
          class="text-color-success"
        >
          {{ $t('mFeedSectionContentCardDesing2.published') }}
        </h3>
        <h3
          v-else
          class="text-color-black-35"
        >
          {{ $t('mFeedSectionContentCardDesing2.draft') }}
        </h3>
      </div>

      <span
        class="font-size-small margin-left-auto"
        v-if="$route.name === 'projects'"
      >
        <a
          class="a-tooltip-primary a-tooltip-bottom margin-right-medium"
          :data-tooltip-text="$t('mFeedSectionContentCardDesing2.tooltipMessages')"
          href="#"
          @click.prevent="goTo('messagges', element.id, element.tipo)"
        >
          <span class="text-color-black-55">
            {{ element.preguntas_sin_responder }}
          </span>
          <span :class="['font-size-small', element.preguntas_sin_responder != 0
            ? 'text-color-fifth-action'
            : 'text-color-seventh-action']"
          >
            <i class="fas fa-comments"></i>
          </span>
        </a>
        <a
          class="a-tooltip-primary a-tooltip-bottom"
          :data-tooltip-text="$t('mFeedSectionContentCardDesing2.tooltipEnrolled')"
          href="#"
          @click.prevent="goTo('enrolled', element.id, element.tipo)"
        >
          <span class="text-color-black-55">
            {{ element.alumnos }}
          </span>
          <span :class="['font-size-small', element.alumnos != 0
            ? 'text-color-sixth-action'
            : 'text-color-seventh-action']"
          >
            <i class="fas fa-users"></i>
          </span>
        </a>
      </span>

      <span
        v-if="isAssetIncludedEdition && !isAssetIncludedRequestLoading"
        key="assetIncludedRequestNotLoading"
      >
        <span :class="[isAssetIncluded ? 'text-color-success' : 'text-color-danger', 'margin-left-auto', 'font-size-small']">
          <i :class="[isAssetIncluded ? 'fas fa-check' : 'fas fa-ban', 'font-size-small']"></i>
          {{ isAssetIncluded
            ? $t('mFeedSectionContentCardDesing2.assetIncluded.included')
            : $t('mFeedSectionContentCardDesing2.assetIncluded.notIncluded')
          }}
        </span>
      </span>
      <span
        v-else-if="isAssetIncludedEdition && isAssetIncludedRequestLoading"
        key="assetIncludedRequestLoading"
      >
        <span :class="[isAssetIncluded ? 'text-color-danger' : 'text-color-success', 'margin-left-auto', 'font-size-small']">
          <i class="fas fa-spinner fa-spin font-size-small"></i>
          {{ isAssetIncluded
            ? $t('mFeedSectionContentCardDesing2.assetIncluded.removing')
            : $t('mFeedSectionContentCardDesing2.assetIncluded.adding')
          }}
        </span>
      </span>
    </div>

    <div
      v-if="isAProductRoute && !isAssetIncludedEdition"
      class="m-card-element-info-state"
    >
      <div class="m-card-element-info-state-of-access">
        <h3
          v-if="element.activo"
          key="available"
          class="text-color-black-45"
        >
          {{ $t('mFeedSectionContentCardDesing2.available') }}
        </h3>
        <h3
          v-else
          key="notAvailable"
          class="text-color-black-35"
        >
          {{ $t('mFeedSectionContentCardDesing2.notAvailable') }}
        </h3>
        <h4
          v-if="element.visible"
          key="visible"
          class="text-color-black-45"
        >
          - {{ $t('mFeedSectionContentCardDesing2.visible') }}
        </h4>
        <h4
          v-else
          key="hidden"
          class="text-color-black-35"
        >
          - {{ $t('mFeedSectionContentCardDesing2.hidden') }}
        </h4>
       </div>
      <router-link
        class="m-card-element-info-state-of-price"
        :to="`/${$t('rPaths.product')}/${element.id}/${$t('mEditionMenu.product.pricesAndPlans.subject')}`"
      >
        {{ productoPrecio }}
      </router-link>
    </div>

  </article>
</template>

<script>
export default {
  name: 'MoleculeFeedSectionContentCardDesign2',

  props: {
    element: Object,
    elementCategorias: Array,
    hideMoveIcon: {
      type: Boolean,
      default: false
    },
    isAssetIncluded: {
      type: Boolean,
      default: false
    },
    isAssetIncludedEdition: {
      type: Boolean,
      default: false
    },
    isAssetIncludedRequestLoading: {
      type: Boolean,
      default: false
    },
    showSelected: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      tarjeta: {
        tipo: 2,
        metadata: {
          imagen: ''
        }
      }
    }
  },

  computed: {
    elementNombre () {
      return this.isAnAssetRoute || this.isAssetIncludedEdition || this.isAMapRoute ? this.element.titulo : this.element.nombre
    },

    isAnAssetRoute () {
      return this.$route.name === 'projects' || this.$route.name === 'asset' || this.$route.meta.isEdition === 'asset'
    },

    isAMapRoute () {
      return this.$route.name === 'projects' || this.$route.name === 'map' || this.$route.meta.isEdition === 'map'
    },

    isAProductRoute () {
      return this.$route.name === 'products' || this.$route.name === 'product' || this.$route.meta.isEdition === 'product'
    },

    productoCategoriaNombre () {
      return this.isAProductRoute && !this.isAssetIncludedEdition
        ? this.element.categoria !== undefined && this.element.categoria.nombre !== undefined
          ? this.element.categoria.nombre
          : this.elementCategorias.find(categoria => categoria.id_producto_categoria === this.element.categoria.id_producto_categoria).nombre
        : ''
    },

    productoPrecio () {
      return this.element.pago ? this.$t('mFeedSectionContentCardDesing2.price.buy') : this.$t('mFeedSectionContentCardDesing2.price.free')
    }
  },

  watch: {
    element () {
      if (this.$route.name === 'academysubChild1' && this.element.imagen) {
        this.tarjeta.metadata = Object.assign({}, { imagen: this.element.imagen })
      }
    }
  },

  created () {
    if (!this.isAssetIncludedEdition &&
      (this.$route.name === 'products' ||
        this.$route.name === 'product' ||
        this.$route.name === 'productChild2') &&
      this.element.tarjeta &&
      this.element.tarjeta === 2) {
      this.tarjeta = Object.assign({}, {
        tipo: this.element.tarjeta,
        metadata: Object.assign({}, this.element.metadata)
      })
    } else if ((this.isAssetIncludedEdition ||
      this.$route.name === 'projects' ||
      this.$route.name === 'asset' ||
      this.$route.name === 'map' ||
      this.$route.name === 'academysubChild1') &&
      this.element.imagen) {
      this.tarjeta.metadata = Object.assign({}, {
        imagen: this.element.imagen
      })
    }
  },

  methods: {
    goTo (route, id, type) {
      const paths = {
        0: {
          messagges: `/${this.$t('rPaths.asset')}/${id}/${this.$t('mEditionMenu.asset.comments.subject')}`,
          enrolled: `/${this.$t('rPaths.asset')}/${id}/${this.$t('mEditionMenu.asset.signedStudents.subject')}/${this.$t('mEditionMenu.asset.signedStudents.children.students.subedition')}`
        },
        1: {
          messagges: `/${this.$t('rPaths.map')}/${id}/${this.$t('mEditionMenu.map.messages.subject')}`,
          enrolled: `/${this.$t('rPaths.map')}/${id}/${this.$t('mEditionMenu.map.enrollments.subject')}/${this.$t('mEditionMenu.map.enrollments.children.students.subedition')}`
        }
      }

      this.$router.push(paths[type][route])
    }
  }
}
</script>
